import React from "react";

export default function VslHero() {
  return (
    <section data-testid="hero-text-section" className="hero-text-pt text-center px-4 pb-6">
      <div className="mx-auto max-w-[860px] lg:max-w-[1280px]">
        <div className="v-label mb-6" style={{ fontSize: "0.864rem" }}>
          SOLO PER SALES BLOCCATI A
          <span className="v-serif" style={{ display: "block", marginTop: "0.35rem", fontStyle: "italic", fontWeight: 400, color: "#FFFFFF", fontSize: "clamp(1.68rem, 5.4vw, 2.76rem)", textTransform: "none", letterSpacing: "normal", lineHeight: 1.1 }}><span style={{ textDecoration: "underline", textUnderlineOffset: "0.15em", textDecorationThickness: "2px" }}>€2k-3k-5k/Mese</span></span>
        </div>

        <h1 className="v-serif v-ink hero-h1" style={{ lineHeight: 1.1, fontWeight: 400 }}>
          Raggiungi i{" "}
          <span className="v-blue" style={{ fontStyle: "italic" }}>€15k/Mese</span>
          <br className="sm:hidden" />
          {" "}Con la
          <br className="hidden sm:inline" />
          {" "}<span style={{ fontStyle: "italic" }}>Vendita in <span style={{ textDecoration: "underline" }}>Nonchalance</span>.</span>
        </h1>

        <div className="mt-6 flex justify-center">
          <ol data-testid="hero-points" className="v-sans text-center hero-points" style={{ color: "#B4B1BA", lineHeight: 1.6, listStyle: "none", padding: 0, margin: 0 }}>
            <li className="py-1">
              <span style={{ color: "#4E85FF", fontWeight: 700, marginRight: "0.5em" }}>1.</span>
              <span>Riprendendo il controllo della tua vita.</span>
            </li>
            <li className="py-1">
              <span style={{ color: "#4E85FF", fontWeight: 700, marginRight: "0.5em" }}>2.</span>
              <span>Rimuovendo Ansia e Stress dalla tua operatività.</span>
            </li>
            <li className="py-1">
              <span style={{ color: "#4E85FF", fontWeight: 700, marginRight: "0.5em" }}>3.</span>
              <span>Arrivando a gestire (quasi) nessuna Obiezione, con Nonchalance.</span>
            </li>
          </ol>
        </div>
      </div>
    </section>
  );
}
